module.exports = __webpack_public_path__ + "static/media/financebanner@2x.3501f885.png";